/**
 *
 * Asynchronously loads the component for ResearchPlate
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const ResearchPlate = lazyLoad(
    () => import('./ResearchPlate'),
    module => module.default,
);
